module.exports = __webpack_public_path__ + "img/plane-sm.3e71829d.svg";